import { reactive } from '@vue/composition-api'
import getYears from '@/composables/useYears'
import committeesApi from '@/services/api/committees'

export default function useReportsFilter(router, onDraftReady) {
  const years = getYears()
  const defaultYear = years[0]

  const state = reactive({
    years,
    year: defaultYear,
    drafts: [],
    draftId: null,
    draftsLoading: false
  })

  function buildQuery() {
    const q = {}
    if (state.year != null) q.year = String(state.year)
    if (state.draftId != null) q.draft_id = String(state.draftId)
    return q
  }

  function pushQuery() {
    router.replace({ query: buildQuery() }).catch(() => {})
  }

  async function fetchDrafts() {
    if (state.year == null) {
      state.drafts = []
      return
    }
    state.draftsLoading = true
    try {
      const res = await committeesApi.drafts({ year: state.year })
      state.drafts = (res.data.data != null ? res.data.data : [])
        .map(d => ({ id: d.id, name: d.name }))
    } catch (_) {
      state.drafts = []
    } finally {
      state.draftsLoading = false
    }
  }

  function setYear(val) {
    state.year = val
    state.draftId = null
    pushQuery()
    fetchDrafts()
  }

  function setDraft(val) {
    state.draftId = val
    pushQuery()
    if (val != null && onDraftReady) onDraftReady()
  }

  async function initFromQuery(query) {
    const qYear = query.year != null ? Number(query.year) : null
    const qDraft = query.draft_id != null ? Number(query.draft_id) : null

    state.year = qYear != null ? qYear : defaultYear

    await fetchDrafts()

    if (qDraft != null && state.drafts.some(d => d.id === qDraft)) {
      state.draftId = qDraft
      if (onDraftReady) onDraftReady()
    }

    if (qYear == null) {
      pushQuery()
    }
  }

  return {
    state,
    setYear,
    setDraft,
    initFromQuery
  }
}



// WEBPACK FOOTER //
// ./src/composables/reports/useReportsFilter.js